import MesureNew from './MeasureNew'

export default MesureNew;